import { render } from "./Privacy.vue?vue&type=template&id=57c2b981&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=57c2b981&scoped=true&lang=css"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c2b981"]])

export default __exports__